<template>
  <el-form :model="form" ref="ruleForm" class="clauseTip">
    <table-form-item
        class="clause"
        :propUrl="`clause`"
        :itemRule="rules['clause']">
        <div class="clauseItem">
          <el-checkbox :class="[isError ? 'errorColor' : '']" v-model="form.clause">
            <div class="tipContent"></div>
          </el-checkbox>
          <div class="tipContent">
            <slot></slot>
          </div>
        </div>
    </table-form-item>
  </el-form>
</template>
<script>
import tableFormItem from "./table-form-item.vue";
import { checkForm } from "~/util/commonUtil";
export default {
  props:{
    currentStep:Number
  },
  components:{
    tableFormItem
  },
  data(){
    return{
      isError: false,
      form:{
        clause: false,
      },
      rules:{
        clause:[
          { validator: this.checkValidate, trigger: ['change'] }
        ],
      },
    }
  },
  methods:{
    checkValidate(rule, value, callback){
      if(!value){
        this.isError = true;
        let temp = '';
        this.currentStep == 1 ?temp = '您需要勾选相关条款才能进入下一步':temp = '您需要同意相关条款才能进行操作';
        callback(temp);
        return;
      }
      this.isError = false
      callback()
    },
    getVail(){
      return checkForm('ruleForm', this);
    },
  }
}
</script>
<style lang="less" scoped>
  // .clauseTip{
  //   margin: 0;
  // }
  .clause{
    margin: 0;
    /deep/ .el-form-item__error{
      display: none;
    }
    .clauseItem {
      line-height: normal;
      /deep/ .el-checkbox__input{
        vertical-align: top;
        top: 2px;
      }
      /deep/ .el-checkbox__label{
        vertical-align: top;
      }
      /deep/ .el-checkbox__label::before{
        content: "*";
        color: #f56c6c;
        vertical-align: top;
        margin-right: 4px;
      }
      .errorColor /deep/ .el-checkbox__inner{
        border-color: #f56c6c;
      }
      .tipContent{
        display: inline-block;
        vertical-align: top;
        color: #333333;
        font-size: 12px;
      }
    }
  }
 
  
</style>